import React from 'react';
import { ReadonlyFieldProps } from './types';

const ReadonlyField: React.FC<ReadonlyFieldProps> = ({
  id,
  label,
  value,
  disabled = true, // Always disabled for readonly
  required = false,
  placeholder = ' ',
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
  formatter,
  missingMessage = 'Unknown',
}) => {
  const displayValue =
    formatter && value ? formatter(value) : value || missingMessage;

  return (
    <div style={styles.floatingFieldContainer}>
      <input
        id={id}
        type="text"
        value={displayValue}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        style={getFloatingInputStyle(false, id)}
        placeholder={placeholder}
        readOnly
      />
      <label htmlFor={id} style={getFloatingLabelStyle(id, hasValue)}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(ReadonlyField);
